export interface PortfolioComparisonKeyParams {
  symbol: string;
  lookback: string;
  resolution: string;
  from?: number;
  to?: number;
  subscribed?: boolean;
}

export const portfolioComparisonQueryKeys = {
  all: ["v3-poc", "portfolio-comparison"] as const,
  range: (params: PortfolioComparisonKeyParams) =>
    [...portfolioComparisonQueryKeys.all, params] as const,
};
